// extracted by mini-css-extract-plugin
export default {"phone":"_Buxa"};